module.exports = __webpack_public_path__ + "img/s1_Slogan.dd0e1309.svg";